import { Modal, Button, Accordion, Card } from "react-bootstrap";
import React, { Component, useState } from "react";
import OnScreenKeyBoard from "./OnScreenKeyBoard";
import VoiceCommand from "./VoiceCommand";
import Dictionary from "./Dictionary";
import TextReaderPopup from "./TextReaderPopup";

const WcagPopup = (props) => {
  const { showHide, handleModalShowHide, handleNavigation } = props;
  const bgColor = "bg-admin-light border-admin-left";

  const [selectedKey, setSelectedKey] = useState(-1);
  const [magnifier, setMagnifier] = useState(false);
  const [highLightHeader, setHighLightHeader] = useState(false);
  const [highLightLinks, setHighLightLinks] = useState(false);
  const [textMagnifier, setTextMagnifier] = useState(false);
  const [readFocus, setReadFocus] = useState(false);
  const [readGuide, setReadGuide] = useState(false);
  const [blackCursor, setBlackCursor] = useState(false);
  const [whiteCursor, setWhiteCursor] = useState(false);
  const [keyboardShowHide, setKeyboardShowHide] = useState(false);
  const [monoChrome, setMonoChrome] = useState(false);
  const [darkHighContrast, setDarkHighContrast] = useState(false);
  const [brightHighContrast, setBrightHighContrast] = useState(false);
  const [lowSaturation, setLowSaturation] = useState(false);
  const [highSaturation, setHighSaturation] = useState(false);
  const [contrastMode, setContrastMode] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState("#ffffff");
  const [headingColor, setHeadingColor] = useState("#000000");
  const [contentColor, setContentColor] = useState("#333333");
  const [bdyFontSize, setBdyFontSize] = useState("13");
  const [bdyLineSpace, setBdyLineSpace] = useState("21");
  const [bdyWordSpace, setBdyWordSpace] = useState("4");
  const [vrKeyboard, setVrKeyboard] = useState(false);
  const [voiceShowHide, setVoiceShowHide] = useState(false);
  const [dictionaryShowHide, setDictionaryShowHide] = useState(false);
  const [dictMode, setDictMode] = useState(false);
  const [voiceMode, setVoiceMode] = useState(false);
  const [textReader, setTextReader] = useState(false);
  const [x, setX] = useState({});
  const [y, setY] = useState({});

  const handleSelect = (e) => {
    setSelectedKey(e)
  };

  const handleMagnifier = () => {
    if (magnifier) document.body.classList.remove("INDmagnifier");
    else document.body.classList.add("INDmagnifier");
    setMagnifier(!magnifier)
  };

  const handleHighLightLinks = () => {
    if (highLightLinks) {
      document.body.classList.remove("INDhighlight");
      document.body.classList.remove("INDhighlightLinks");
    } else {
      document.body.classList.add("INDhighlight");
      document.body.classList.add("INDhighlightLinks");
    }
    setHighLightLinks(!highLightLinks)
  };

  const handleHighLightHeader = () => {
    if (highLightHeader) {
      document.body.classList.remove("INDhighlight");
      document.body.classList.remove("INDhighlightHeaders");
    } else {
      document.body.classList.add("INDhighlight");
      document.body.classList.add("INDhighlightHeaders");
    }
    setHighLightLinks(!highLightLinks)
  };

  const handleTextMagnifier = () => {
    if (textMagnifier) document.body.classList.remove("INDtextmagnifier");
    else document.body.classList.add("INDtextmagnifier");
    setTextMagnifier(!textMagnifier)
  };

  const handleReadFocus = () => {
    if (readFocus) document.body.classList.remove("INDfocusmode");
    else document.body.classList.add("INDfocusmode");
    setReadFocus(!readFocus)
  };

  const handleReadGuid = () => {
    if (readGuide) document.body.classList.remove("INDreadguide");
    else document.body.classList.add("INDreadguide");
    setReadGuide(!readGuide)
  };

  const handleWhiteCursor = () => {
    if (whiteCursor) {
      document.body.classList.remove("INDbigcursor");
      document.body.classList.remove("INDwhitecursor");
    } else {
      document.body.classList.add("INDbigcursor");
      document.body.classList.add("INDwhitecursor");
    }
    setWhiteCursor(!whiteCursor)
  };

  const handleBlackCursor = () => {
    if (blackCursor) {
      document.body.classList.remove("INDbigcursor");
      document.body.classList.remove("INDblackcursor");
    } else {
      document.body.classList.add("INDbigcursor");
      document.body.classList.add("INDblackcursor");
    }
    setBlackCursor(!blackCursor)
  };

  const handleKeyboardShowHide = () => {
    //alert("test");
    //console.log(document.body.classList);
    //const { vrKeyboard } = this.state;
    if (vrKeyboard) document.body.classList.remove("INDvirtualKeyboard");
    else document.body.classList.add("INDvirtualKeyboard");
    setVrKeyboard(!vrKeyboard)
    handleModalShowHide();
  };

  const onMouseMove = (e) => {
    setX(e.nativeEvent.offsetX)
    setY(e.nativeEvent.offsetY)
  };

  const handleMonoChrome = () => {
    if (monoChrome) {
      document.body.classList.remove("INDcolorscheme");
      document.body.classList.remove("INDmonochrome");
    } else {
      document.body.classList.add("INDcolorscheme");
      document.body.classList.add("INDmonochrome");
    }
    setMonoChrome(!monoChrome)
  };

  const handleDarkHighContrast = () => {
    if (darkHighContrast) {
      document.body.classList.remove("INDcolorscheme");
      document.body.classList.remove("INDblackwhite");
    } else {
      document.body.classList.add("INDcolorscheme");
      document.body.classList.add("INDblackwhite");
    }
    setDarkHighContrast(!darkHighContrast)
  };

  const handleBrightHighContrast = () => {
    if (brightHighContrast) {
      document.body.classList.remove("INDcolorscheme");
      document.body.classList.remove("INDwhiteblack");
    } else {
      document.body.classList.add("INDcolorscheme");
      document.body.classList.add("INDwhiteblack");
    }
    setBrightHighContrast(!brightHighContrast)
  };

  const handleLowSaturation = () => {
    if (lowSaturation) {
      document.body.classList.remove("INDcolorscheme");
      document.body.classList.remove("INDlowHue");
    } else {
      document.body.classList.add("INDcolorscheme");
      document.body.classList.add("INDlowHue");
    }
    setLowSaturation(!lowSaturation)
  };

  const handleHighSaturation = () => {
    if (highSaturation) {
      document.body.classList.remove("INDcolorscheme");
      document.body.classList.remove("INDhighHue");
    } else {
      document.body.classList.add("INDcolorscheme");
      document.body.classList.add("INDhighHue");
    }
    setHighSaturation(!highSaturation)
  };

  const handleContrastMode = () => {
    if (contrastMode) {
      document.body.classList.remove("INDcolorscheme");
      document.body.classList.remove("INDautoConFix");
    } else {
      document.body.classList.add("INDcolorscheme");
      document.body.classList.add("INDautoConFix");
    }
    setContrastMode(!contrastMode)
  };

  const handleBgChange = (event) => {
    const color = event.target.value;
    document.documentElement.style.setProperty("--ind-color-bg-picker", color);
    document.documentElement.style.setProperty("--ind-color-picker", color);
    document.body.classList.add("INDcolorscheme", "INDcustomcolor", "INDbackgroundColors");
    setBackgroundColor(color);
  };

  const handleHeadingChange = (event) => {
    const color = event.target.value;
    document.documentElement.style.setProperty("--ind-color-heading-picker", color);
    document.documentElement.style.setProperty("--ind-color-picker", color);
    document.body.classList.add("INDcolorscheme", "INDcustomcolor", "INDheadingColors");
    setHeadingColor(color);
  };

  const handleContentChange = (event) => {
    const color = event.target.value;
    document.documentElement.style.setProperty("--ind-color-text-picker", color);
    document.documentElement.style.setProperty("--ind-color-picker", color);
    document.body.classList.add("INDcolorscheme", "INDcustomcolor", "INDtextColors");
    setContentColor(color);
  };


  const handleResetColor = () => {
    document.body.classList.remove("INDcolorscheme");
    document.body.classList.remove("INDcustomcolor");
    document.body.classList.remove("INDbackgroundColors");
    document.body.classList.remove("INDheadingColors");
    document.body.classList.remove("INDtextColors");
    setHeadingColor("");
    setBackgroundColor("");
    setContentColor("");
  };


  const handleFontSize = (event) => {
    const newSize = event.currentTarget.value;
    document.body.style.fontSize = newSize + "px";
    setBdyFontSize(Number(newSize));
  };

  const handleSpaceSize = (event) => {
    const newSize = event.currentTarget.value;
    document.body.style.lineHeight = newSize + "px";
    setBdyLineSpace(Number(newSize));
  };

  const HandleWordSpacing = (event) => {
    const newSize = event.currentTarget.value;
    document.body.style.wordSpacing = newSize + "px";
    setBdyWordSpace(Number(newSize));
  };

  const handleResetFont = () => {
    document.body.style.removeProperty("font-size");
    document.body.style.removeProperty("line-height");
    document.body.style.removeProperty("word-spacing");
    setBdyFontSize("13")
    setBdyLineSpace("21")
    setBdyWordSpace("4")
  };

  const handleVoiceShowHide = () => {
    if (voiceMode) {
      document.body.classList.remove("INDvoicecmd");
    } else {
      document.body.classList.add("INDvoicecmd");
    }
    setVoiceShowHide(!voiceShowHide)
    handleModalShowHide();
  };

  const handledictionaryShowHide = () => {
    document.body.classList.add("INDdictionary");
    setDictMode(!dictMode)
    setDictionaryShowHide(!dictionaryShowHide)
    handleModalShowHide();
  };

  const handleTextReader = () => {
    if (textReader) {
      document.body.classList.remove("INDtextreader");
    } else {
      document.body.classList.add("INDtextreader");
      setTextReader(true)
    }
  };

  const handleTextReaderShowHide = () => {
    setTextReader(false)
  };

  return (
    <React.Fragment>
      <Modal
        show={showHide}
        size={"lg"}
        dialogClassName="modalLeftRight modalRight"
      >
        <Modal.Header closeButton onClick={handleModalShowHide}>
          <Modal.Title>
            <img
              src="/assets/img/wcagIcon.png"
              alt="Web Content Accessibility Guidelines Image Button"
              title="Web Content Accessibility Guidelines (WCAG)"
              className="w-10 mr-2"
            />
            Web Content Accessibility
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary">
          <div className="row">
            <div className="col-md-12 mt-4">
              <Accordion onSelect={handleSelect}>
                <Card className="shadow-none border">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="0"
                    className={`p-3 card-header1 ${bgColor}`}
                    aria-expanded={
                      selectedKey === "0" ? "true" : "false"
                    }
                  >
                    <h4 className="mb-0">
                      <i className="fa fa-bars mr-2" aria-hidden="true"></i>
                      Navigation Adjustment
                    </h4>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <div className="col-md-12 p-3">
                      <div className="row">
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                          >
                            <i
                              className="fa fa-desktop mr-2"
                              aria-hidden="true"
                            ></i>
                            Screen Reader Adjustment
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleNavigation}
                          >
                            <i
                              className="fa fa-keyboard-o mr-2"
                              aria-hidden="true"
                            ></i>
                            Keyboard Navigation
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleNavigation}
                          >
                            <i
                              className="fa fa-cogs mr-2"
                              aria-hidden="true"
                            ></i>
                            Smart Navigation
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                          >
                            <i
                              className="fa fa-braille mr-2"
                              aria-hidden="true"
                            ></i>
                            Blinks Blocking
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleTextReader}
                          >
                            <i
                              className="fa fa-file-text-o mr-2"
                              aria-hidden="true"
                            ></i>
                            Text Reader
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleVoiceShowHide}
                          >
                            <i
                              className="fa fa-microphone mr-2"
                              aria-hidden="true"
                            ></i>
                            Voice Commands
                          </button>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
                <Card className="shadow-none border">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="1"
                    className={`p-3 card-header1 ${bgColor}`}
                    aria-expanded={
                      selectedKey === "1" ? "true" : "false"
                    }
                  >
                    <h4 className="mb-0">
                      <i
                        className="fa fa-tachometer mr-2"
                        aria-hidden="true"
                      ></i>
                      Color Adjustment
                    </h4>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="1">
                    <div className="col-md-12 p-3">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card card-body border shadow-none bg-secondary">
                            <div className="row">
                              <div className="col-md-12 form-group">
                                <h3 className="mb-0">Custom Color</h3>
                                <p>Change Site's Colors</p>
                              </div>
                              <div className="col-md-12 form-group">
                                <label htmlFor="backgroundColor">
                                  Backgrounds
                                </label>
                                <input
                                  className="form-control"
                                  type="color"
                                  onChange={handleBgChange}
                                  id="backgroundColor"
                                  name="backgroundColor"
                                  value={backgroundColor}
                                />
                              </div>
                              <div className="col-md-12 form-group">
                                <label htmlFor="headingColor">Headings</label>
                                <input
                                  className="form-control"
                                  type="color"
                                  onChange={handleHeadingChange}
                                  id="headingColor"
                                  name="headingColor"
                                  value={headingColor}
                                />
                              </div>
                              <div className="col-md-12 form-group">
                                <label htmlFor="contentColor">Contents</label>
                                <input
                                  className="form-control"
                                  type="color"
                                  onChange={handleContentChange}
                                  id="contentColor"
                                  name="contentColor"
                                  value={contentColor}
                                />
                              </div>
                              <div className="col-md-12">
                                <button
                                  className="btn btn-outline-default"
                                  onClick={handleResetColor}
                                >
                                  Reset Colors
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleMonoChrome}
                          >
                            <i
                              className="fa fa-eraser mr-2"
                              aria-hidden="true"
                            ></i>
                            Monochrome
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleDarkHighContrast}
                          >
                            <i
                              className="fa fa-cube mr-2"
                              aria-hidden="true"
                            ></i>
                            Dark High-Contrast
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleBrightHighContrast}
                          >
                            <i
                              className="fa fa-cubes mr-2"
                              aria-hidden="true"
                            ></i>
                            Bright High-Contrast
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleLowSaturation}
                          >
                            <i
                              className="fa fa-hourglass-half mr-2"
                              aria-hidden="true"
                            ></i>
                            Low saturations
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleHighSaturation}
                          >
                            <i
                              className="fa fa-hourglass mr-2"
                              aria-hidden="true"
                            ></i>
                            High saturations
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100"
                            onClick={handleContrastMode}
                          >
                            <i
                              className="fa fa-square mr-2"
                              aria-hidden="true"
                            ></i>
                            Contrast mode
                          </button>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
                <Card className="shadow-none border">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="2"
                    className={`p-3 card-header1 ${bgColor}`}
                    aria-expanded={
                      selectedKey === "2" ? "true" : "false"
                    }
                  >
                    <h4 className="mb-0">
                      <i
                        className="fa fa-window-restore mr-2"
                        aria-hidden="true"
                      ></i>
                      Content Adjustment
                    </h4>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="2">
                    <div className="col-md-12 p-3">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card card-body border shadow-none bg-secondary">
                            <div className="row">
                              <div className="col-md-12 form-group">
                                <h3 className="mb-0">Font sizing</h3>
                                <p>Increase and Decerease the Font Size</p>
                              </div>
                              <div className="col-md-12 form-group">
                                <label htmlFor="bcColor">Font Size</label>
                                <input
                                  type="range"
                                  className="form-control-range"
                                  id="fontSize"
                                  min="13"
                                  max="20"
                                  onChange={handleFontSize}
                                  value={bdyFontSize}
                                />
                              </div>
                              <div className="col-md-12 form-group">
                                <label htmlFor="lineSpacing">
                                  Line spacing
                                </label>
                                <input
                                  type="range"
                                  className="form-control-range"
                                  id="lineSpacing"
                                  min="21"
                                  max="32"
                                  onChange={handleSpaceSize}
                                  value={bdyLineSpace}
                                />
                              </div>
                              <div className="col-md-12 form-group">
                                <label htmlFor="wordSpace">
                                  Word spacing
                                </label>
                                <input
                                  type="range"
                                  className="form-control-range"
                                  id="wordSpace"
                                  min="4"
                                  max="8"
                                  onChange={HandleWordSpacing}
                                  value={bdyWordSpace}
                                />
                              </div>
                              <div className="col-md-12">
                                <button
                                  className="btn btn-outline-default"
                                  onClick={handleResetFont}
                                >
                                  Reset Font Style
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="card card-body border shadow-none bg-secondary">
                            <div className="row">
                              <div className="col-md-12 form-group">
                                <h3 className="mb-0">Cursor</h3>
                                <p>Enlarge the cursor and Change its color</p>
                              </div>
                              <div className="col-md-6">
                                <button
                                  className="btn btn-outline-secondary border w-100 h-100 bg-white"
                                  onClick={handleWhiteCursor}
                                >
                                  <i
                                    className="fa fa-circle-o mr-2"
                                    aria-hidden="true"
                                  ></i>
                                  WHITE
                                </button>
                              </div>
                              <div className="col-md-6">
                                <button
                                  className="btn btn-default w-100 h-100"
                                  onClick={handleBlackCursor}
                                >
                                  <i
                                    className="fa fa-circle mr-2"
                                    aria-hidden="true"
                                  ></i>
                                  BLACK
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleMagnifier}
                          >
                            <i
                              className="fa fa-search mr-2"
                              aria-hidden="true"
                            ></i>
                            Magnifier
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                          >
                            <i
                              className="fa fa-font mr-2"
                              aria-hidden="true"
                            ></i>
                            Readable Font
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                          >
                            <i
                              className="fa fa-picture-o mr-2"
                              aria-hidden="true"
                            ></i>
                            Image Description
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleHighLightLinks}
                          >
                            <i
                              className="fa fa-link mr-2"
                              aria-hidden="true"
                            ></i>
                            Highlight Links
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleHighLightHeader}
                          >
                            <i
                              className="fa fa-header mr-2"
                              aria-hidden="true"
                            ></i>
                            Highlight Headers
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                          >
                            <i
                              className="fa fa-eye mr-2"
                              aria-hidden="true"
                            ></i>
                            Readable Mode
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleTextMagnifier}
                          >
                            <i
                              className="fa fa-magic mr-2"
                              aria-hidden="true"
                            ></i>
                            Text Magnifier
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleReadFocus}
                          >
                            <i
                              className="fa fa-thumb-tack mr-2"
                              aria-hidden="true"
                            ></i>
                            Read Focus
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleReadGuid}
                          >
                            <i
                              className="fa fa-window-minimize mr-2"
                              aria-hidden="true"
                            ></i>
                            Reading Guide
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handledictionaryShowHide}
                          >
                            <i
                              className="fa fa-book mr-2"
                              aria-hidden="true"
                            ></i>
                            Dictionary
                          </button>
                        </div>
                        <div className="col-md-6 form-group">
                          <button
                            type="button"
                            className="btn btn-outline-default w-100 h-100"
                            onClick={handleKeyboardShowHide}
                          >
                            <i
                              className="fa fa-keyboard-o mr-2"
                              aria-hidden="true"
                            ></i>
                            Virtual Keyboard
                          </button>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
                <Card className="shadow-none border">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="3"
                    className={`p-3 card-header1 ${bgColor}`}
                    aria-expanded={
                      selectedKey === "3" ? "true" : "false"
                    }
                  >
                    <h4 className="mb-0">
                      <i className="fa fa-check mr-2" aria-hidden="true"></i>
                      Web Accessibility Evaluation Tool
                    </h4>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="3">
                    <div className="col-md-12 p-3">
                      <div className="row">
                        <div className="col-md-12">
                          <a
                            href="https://wave.webaim.org/"
                            className="btn btn-outline-default"
                            target="_blank"
                          >
                            WAVE Web Accessibility Evaluation Tool
                          </a>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
            <div className="col-md-12">
              <b>Voice Commands and Text Reader Supported Browser</b>
              <br></br>
              1. Chrome Browser for Desktop and Android
              <br></br>
              2. Edge Browser for Desktop and Android
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer className="justify-content-center">
          <Button variant="outline-danger" size="sm" onClick={handleModalShowHide}>
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </Button>
        </Modal.Footer> */}
      </Modal>
      <VoiceCommand
        voiceShowHide={voiceShowHide}
        handleVoiceShowHide={handleVoiceShowHide}
      ></VoiceCommand>
      <Dictionary
        dictionaryShowHide={dictionaryShowHide}
        handledictionaryShowHide={handledictionaryShowHide}
      ></Dictionary>
      <TextReaderPopup
        textReaderShowHide={textReader}
        handleTextReaderShowHide={handleTextReaderShowHide}
      ></TextReaderPopup>
    </React.Fragment>
  );
  // }
}

export default WcagPopup;
